import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../components/modal/components/modal-restricted/withRestrictedModal';
import { PopoverFactoryRenderer } from '../../../components/popovers/PopoverFactoryRenderer';
import { DecisionSeparator } from '../../components/decision-separator/DecisionSeparator';
import { DecisionQpcInSnippet } from '../../decision.types';
import styles from './decision_qpc_list.module.scss';
import {
  DecisionsLegislationSnippetLink,
  DecisionsLegislationSnippetContainer,
  DecisionsLegislationSnippetTitle,
  DecisionsLegislationSnippetList,
} from '../components/DecisionsLegislationSnippetComponents';
import { LegislationSnippetDecisionPopover } from '../popover/LegislationSnippetDecisionPopover';

type Props = {
  decisions: Array<DecisionQpcInSnippet>;
  source: string;
} & WithRestrictedModalProps;

export const RawDecisionQpcList: FC<Props> = ({
  source,
  openRestrictedModal,
  decisions,
}) => {
  const onClick = () => {
    openRestrictedModal(source);
  };

  const displayPopover = (element: HTMLElement) => {
    const indexString = element.getAttribute('data-decision');
    if (indexString) {
      const index = parseInt(indexString, 10);
      return (
        <LegislationSnippetDecisionPopover
          source="decision-decision_qpc_popover"
          decision={decisions[index]}
        />
      );
    }
  };

  return (
    <DecisionsLegislationSnippetContainer>
      <DecisionsLegislationSnippetTitle>
        <FormattedMessage
          id="decision/qpc/DecisionQpcList.tsx/1"
          values={{ count: decisions.length }}
        />
      </DecisionsLegislationSnippetTitle>
      <PopoverFactoryRenderer renderTemplate={displayPopover}>
        <DecisionsLegislationSnippetList>
          {decisions.map((decision, index) => (
            <li key={decision.docId}>
              <>
                <DecisionsLegislationSnippetLink
                  index={index}
                  url={decision.url}
                  source={source}
                  onClick={onClick}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: decision.referenceCitation,
                    }}
                  />
                </DecisionsLegislationSnippetLink>
                {decision.solutionCc && (
                  <>
                    <DecisionSeparator />
                    <span className={styles.solution}>
                      <FormattedMessage
                        id="decision/qpc/DecisionQpcList.tsx/4"
                        values={{ solution: decision.solutionCc }}
                      />
                    </span>
                  </>
                )}
              </>
            </li>
          ))}
        </DecisionsLegislationSnippetList>
      </PopoverFactoryRenderer>
    </DecisionsLegislationSnippetContainer>
  );
};

export const DecisionQpcList = withRestrictedModal(RawDecisionQpcList);
